import {ArtikelFarbVariante, ColorCodeFarbKombiBeziehung, Produktresponse} from "./databaseInterfaceClasses";
import {EventVerteiler} from "../global/eventVerteiler";
import {AutomaticFeatureChanger} from "./controllerModules/automaticFeatureChanger";
import globalsObject, {translate} from "./globalsObject";
import DEBUG from "./DEBUG";
import {deepCopy} from "../global/deepCopy";
import {arrayElementByKeyValue} from "../global/arrayHelper";
import {alertIfDebug} from "../global/logFunctions";
import {CONTROLLER_EVENTNAMES} from "@k/global/GlobalEventnames";


export type Feature = {
    Feature : string
    Kuerzel : string
    Name : string
    einzublendendeDreiDParts : string
    imKonfiBeiDerProduktuebersichtAuswaehlbar : string
    imKonfiVerstecktesAberFuerPreisberechnungRelevantesFeature : string
    isFeaturedObjectSichtbarLautDBAbfrage : string
    detailImageURL : string
}

export type FeaturedObject ={
    FeaturedObject : string,
    FeaturedObjectWeb : string,
    Features : Feature[],
    Name : string,
    StandardFeature : string,
    zeigeZugehoerigeFeatureBeiFeatureAuswahlAn : string,
}

export type ProduktRegel ={
    Feature1A : string,
    Feature1B : string,
    Feature2 : string,
    FeaturedObject2 : string,
    GebotVerbot : string,
    Geschlecht : string,
}

export type AuswahlProdukt ={
    AuwiProdukt : string,
    DVSchnitt : string,
    Designliste : string,
    FeaturedObjects : FeaturedObject[],
    Geschlecht : string,
    Name : string,
    Ordertype : string,
    Produkt : string,
    Realsport : string,
    Regeln : ProduktRegel[],
    Schnitt : string,
    Sportart : string,
    Urlname : string,
    features : SelectedFeature[],
    preview : string,
    // Produktzusatz : string,
    Produktansicht : string,
    discarded : boolean,
    ImKonfiKoennenPatternsVerwendetWerden:boolean
}


/**
 * @classdesc das "SelectedFeature" für einen Entwurf.
 * Beschreibt die für ein Produkt ausgewählten Feature
 * * FeatureObject
 * * Feature
 * * Kürzel
 * @class
 * @constructor
 */
export class SelectedFeature {
    public featuredObject : string;
    public feature : string;
    public name : string;
    public abkuerzung : string;
    public einzublendendeDreiDParts : string;
    public imKonfiBeiDerProduktuebersichtAuswaehlbar : string;
    public imKonfiVerstecktesAberFuerPreisberechnungRelevantesFeature : string;
    public isFeaturedObjectSichtbarLautDBAbfrage : string;
    public VorbelegungPreisanzeige : number;

    constructor(featuredObject, feature, name, abkuerzung, einzublendendeDreiDParts, imKonfiBeiDerProduktuebersichtAuswaehlbar, imKonfiVerstecktesAberFuerPreisberechnungRelevantesFeature, isFeaturedObjectSichtbarLautDBAbfrage) {
        this.featuredObject = featuredObject; // die feature Kategorie
		this.feature = feature; //das tatsächliche Feature (z.b. V-Kragen)s
		this.name = name; //der lokalisierte Name (z.b. V-Collar , o. ä.)
		this.abkuerzung = abkuerzung; //die Abkuerzung (brauchen wir zur Generierung des Modelnamens)
		/* Durch dieses Feature werden optionale Parts im 3d Modell eingeblendet. (z.B: Das kürzel RVP blendet den Part RVP_oprional ein.)
		 * Mehrere Parts werden durch ein ";" getrennt.
		 */
		this.einzublendendeDreiDParts = einzublendendeDreiDParts;
		this.imKonfiBeiDerProduktuebersichtAuswaehlbar = imKonfiBeiDerProduktuebersichtAuswaehlbar;
		this.imKonfiVerstecktesAberFuerPreisberechnungRelevantesFeature = imKonfiVerstecktesAberFuerPreisberechnungRelevantesFeature;
		this.isFeaturedObjectSichtbarLautDBAbfrage = isFeaturedObjectSichtbarLautDBAbfrage;
		this.VorbelegungPreisanzeige = 1;
	}

	public clone() {
        return new SelectedFeature(
            this.featuredObject,
            this.feature,
            this.name,
            this.abkuerzung,
            this.einzublendendeDreiDParts,
            this.imKonfiBeiDerProduktuebersichtAuswaehlbar,
            this.imKonfiVerstecktesAberFuerPreisberechnungRelevantesFeature,
            this.isFeaturedObjectSichtbarLautDBAbfrage
        );
    }
}

export type ProduktDesignFromProduktPHP = {
     Design:string;
     Realdesign;
     Pfad;

     baseColors:string[];
     ColorCodesWithOutline;
     KonfiDiscarded;
     ColorCodeAbhaengigkeiten;
     ausgeblendeteColorCodes;
};

/**
 * @classdesc das "ProductObject" für ein owayo Produkt.
 * Hier sind produktspezifische Informationen wie
 * * designliste
 * * mögliche größen
 * * evtl Preise
 * @class
 * @param {string} produkt
 * @param {string} name
 * @param {string} cut
 * @param {string} ordertype
 * @param {string} realsport
 * @param {string} designlist
 */
export class Product {
    public produkt;
    public name;
    public cut;
    public schnitt;
    public ordertype;
    public sportart;
    public realsport;
    public basemodel;
    public model;
    public basisdesign;
    public possibleDesigns:ProduktDesignFromProduktPHP[];
    public possibleSizes;
    public fehlendeRohlingGroessen;
    public selectedFeatures:SelectedFeature[];
    public partMaterials;
    public defaults;
    public designList;
    public drehungInDesignauswahl;
    public maxNeigungBogenmass;
    public maxDrehungBogenmass;
    public defaultMaterial;
    public VorbelegungPreisanzeige;
    public mindestBestellung;
    public maximalBestellung;
    public warnungen;
    public productWebInt;
    public mengenBezeichner;
    VorgegebenerArtikel;
    Farbvarianten:ArtikelFarbVariante[][];
    public colorCodes;
    public ColorCodeFarbVorbelegungen;
    public DesigncheckDisabled = false;
    public TackleTwillMoeglich = false;
    public droppableParts: string[] = [];
    public automaticfeatureController:AutomaticFeatureChanger|null = null;
    public farbBeziehungenZwischenColorCodes:ColorCodeFarbKombiBeziehung[] = [];
    public designvorschaupfad="";
    public imKonfiKoennenPatternsVerwendetWerden: boolean;
    public hatReadyDesigns:boolean
    public productWebNormalized: string;
    public websportUnterDemDasProduktGehostetIst: string;
    public websportUnterDemDasProduktGehostetIstUebersetzt:string;

    constructor(produkt, name, cut, ordertype, realsport, designlist) {
        this.produkt = produkt;
        this.name = name;
        this.cut = cut;
        this.schnitt = "";
        this.ordertype = ordertype;
        this.sportart = "";
        this.realsport = realsport;
        this.basemodel = "";
        this.model = "";
        this.basisdesign = "";
        this.possibleDesigns = [];
        this.possibleSizes = [];
        this.selectedFeatures = [];
        this.partMaterials = [];
        this.defaults = {
            size: null,
            design: null
        };
        this.designList = designlist;
        this.warnungen = [];
    }

    /*
     * Klont das produkt und gibt ein neues Objekt zurück.
     * FIXME Vorsicht, jedesmal wenn eine neue Eigenschaft dazukommt muss diese Funktion geupdated werden!
     * @return {Product}
     */
    clone() {
        const output = new Product(
            this.produkt,
            this.name,
            this.cut,
            this.ordertype,
            this.realsport,
            this.designList
        );
        output.schnitt = this.schnitt;
        output.sportart = this.sportart;
        output.basemodel = this.basemodel;
        output.model = this.model;
        output.basisdesign = this.basisdesign;
        output.possibleDesigns = deepCopy(true, [], this.possibleDesigns);
        output.possibleSizes = deepCopy(true,  [], this.possibleSizes);
        output.selectedFeatures = deepCopy( true, [], this.selectedFeatures);
        output.partMaterials = deepCopy(true, [], this.partMaterials);
        output.defaults = deepCopy(  true, {}, this.defaults);
		output.fehlendeRohlingGroessen = this.fehlendeRohlingGroessen;
        output.drehungInDesignauswahl = this.drehungInDesignauswahl;
        output.maxNeigungBogenmass = this.maxNeigungBogenmass;
        output.maxDrehungBogenmass = this.maxDrehungBogenmass;
        output.mindestBestellung = this.mindestBestellung;
        output.maximalBestellung = this.maximalBestellung;
        output.warnungen = deepCopy(true, [], this.warnungen);
        output.productWebInt = this.productWebInt;
        output.productWebNormalized = this.productWebNormalized;
        output.ColorCodeFarbVorbelegungen = this.ColorCodeFarbVorbelegungen;
        output.colorCodes = this.colorCodes;
        output.DesigncheckDisabled = this.DesigncheckDisabled;
        output.farbBeziehungenZwischenColorCodes = this.farbBeziehungenZwischenColorCodes;
        output.VorbelegungPreisanzeige = this.VorbelegungPreisanzeige;

        output.mengenBezeichner = this.mengenBezeichner;
        output.VorgegebenerArtikel = this.VorgegebenerArtikel;
        output.Farbvarianten = deepCopy(true, [], this.Farbvarianten);
        output.droppableParts = this.droppableParts.splice(0);
        output.automaticfeatureController = this.automaticfeatureController;
        output.designvorschaupfad = this.designvorschaupfad;
        output.imKonfiKoennenPatternsVerwendetWerden = this.imKonfiKoennenPatternsVerwendetWerden;
        output.hatReadyDesigns = this.hatReadyDesigns;
        output.websportUnterDemDasProduktGehostetIst = this.websportUnterDemDasProduktGehostetIst;
        output.websportUnterDemDasProduktGehostetIstUebersetzt = this.websportUnterDemDasProduktGehostetIstUebersetzt;
        return output;
    }



    /**
     * Wir ersetzen in den Design Pfaden [model] mit dem Model
     */
    updateDesignPreviewPath() {
        const $this = this;
        this.possibleDesigns = this.possibleDesigns.map(function(design) {
            design.Pfad = design.Pfad.replace("[model]", $this.model);
            return design;
        });
    }

    private static createMaterialSelectedFeatureWithdefaultMaterial(defaultMaterial) {
        return new SelectedFeature("Material",defaultMaterial,defaultMaterial,null,
            '',
            "0",
            "1",
            "0"
        );
    }

    /**
     * Wir übegeben ein DataObjekt, das aus der produkt.php kommt und machen die restliche Inistalisierung
     */
    initAdditionalInfos(data:Produktresponse, sportart, features) {
        this.sportart = sportart;
        this.websportUnterDemDasProduktGehostetIst = data.websportUnterDemDasProduktGehostetIst;
        this.websportUnterDemDasProduktGehostetIstUebersetzt = data.websportUnterDemDasProduktGehostetIstUebersetzt;
        this.schnitt = data.Schnitt;
        this.possibleSizes = data.Sizes;
        if(this.possibleSizes.length === 0 && DEBUG) {
            this.possibleSizes.push({Positione: "2", name: "2  (XS)", size: "2"});
        }
        this.selectedFeatures = features || [];
        this.basemodel = data.Basemodel;
        this.basisdesign = data.BasisDesign;
        this.possibleDesigns = deepCopy( true, [], data.Designs);
        this.fehlendeRohlingGroessen = data.FehlendeRohlinge;
        this.name = data.Name;
        this.drehungInDesignauswahl = parseInt(data.drehungInDesignauswahl, 10);
        this.maxNeigungBogenmass = parseInt(data.maxNeigung, 10) * Math.PI / 180;
        this.maxDrehungBogenmass = parseInt(data.maxDrehung, 10) * Math.PI / 180;
        this.defaultMaterial = data.DefaultMaterial;
        this.partMaterials = data.partMaterials;
        this.VorbelegungPreisanzeige = parseInt(data.VorbelegungPreisanzeige);
        this.mindestBestellung = parseInt(data.MindestBestellung, 10);
        this.maximalBestellung = parseInt(data.MaximalBestellung, 10);
        this.warnungen = deepCopy( true, [], data.Warnungen);
        this.productWebInt = data.Urlname;
        this.productWebNormalized = data.webproduktNormalized;
        this.mengenBezeichner = data.MengenBezeichner;
        this.VorgegebenerArtikel = data.VorgegebenerArtikel;
        this.Farbvarianten = deepCopy(true, [], data.Farbvarianten);
        this.colorCodes = data.colorCodes;
        this.ColorCodeFarbVorbelegungen = data.ColorCodeFarbVorbelegungen;
        this.DesigncheckDisabled = data.DesigncheckDisabled;
        this.TackleTwillMoeglich = data.TackleTwillMoeglich;
        this.droppableParts = data.namesOfDroppableParts;
        if (data.DefaultMaterial !== null  && this.selectedFeatures?.find(sf => sf.featuredObject === "Material") !== undefined) {
            this.selectedFeatures.push(Product.createMaterialSelectedFeatureWithdefaultMaterial(data.DefaultMaterial));
        }
        this.model = getModelName(this.basemodel, this.selectedFeatures);


        if (this.model === "") {
            return;
        }
        if (this.model !== data.model) {
            if (DEBUG) {
                globalsObject.controller.handleError("internal", "initAdditinalInfos", "Vorsicht!!! data.model ist " + data.model + ", aber this.model ist " + this.model);
            }
        }

        if (this.warnungen.find(w => w.meldefall === "Warenkorbposition") !== undefined){
            this.displayProduktWarnung();
        }

        this.updateDesignPreviewPath();
        this.farbBeziehungenZwischenColorCodes = data.farbBeziehungenZwischenColorCodes;
        this.designvorschaupfad = data.designvorschaupfad
        this.imKonfiKoennenPatternsVerwendetWerden = data.imKonfiKoennenPatternsVerwendetWerden;
        this.hatReadyDesigns = data.hatReadyDesigns;
        EventVerteiler.broadcast("setButtonVisibilityForFeaturesEvent", features);
        EventVerteiler.broadcast("setTackleTwillVisibility", this.TackleTwillMoeglich);
    }

    displayProduktWarnung() {
        let message = '';
        if (this.warnungen.length<1){
            return;
        }
        const buttons = [
            {
                color: "blue",
                text: translate("konf_OK", "Okay"),
                closeAfter: true
            }
        ];

        for (let i = 0; i < this.warnungen.length; i++) {
            if(this.warnungen[i].meldefall === "Warenkorbposition") {
                message += translate(this.warnungen[i].contentID, '') + '<br>';
            }
        }

        EventVerteiler.broadcast(
            "displayCustomDialogEvent",
            {
                cssClass: "notice",
                title: translate('konf_warning', 'Achtung!'),
                message: message.substring(0, message.lastIndexOf('<br>')),
                buttons: buttons
            }
        );
    }

    getDesignObject = designName=>arrayElementByKeyValue(this.possibleDesigns, "Design", designName);
    getDesignObjectByRealdesign = designName=>arrayElementByKeyValue(this.possibleDesigns, "Realdesign", designName);
    getBaseDesign = ()=>this.getDesignObject(this.basisdesign) || this.getDesignObjectByRealdesign(this.basisdesign);

    public hasFixedAmount() {
        return [typeof(this.mindestBestellung),typeof(this.maximalBestellung)].indexOf("undefined") === -1 && this.mindestBestellung === this.maximalBestellung;
    }
}


function getAbkuerzungFromSelectedFeatures(selectedFeatures:SelectedFeature[], featuredObjectName) {
    for (let i = 0, len = selectedFeatures.length; i < len; i++) {
        if (selectedFeatures[i].featuredObject === featuredObjectName) {
            return selectedFeatures[i].abkuerzung.replace(/\//g, "");
        }
    }
    return null;
}

export function getModelName(basemodel:string|null, selectedFeatures) {
    if(basemodel === null) {
        return "";
    }
    const inSquareBrackets = /\[(.*?)]/g;
    // const hits = [...basemodel.matchAll(inSquareBrackets)].map(h=> ({complete: h[0], fo: h[1]}));

    const hits = [];
    let match;
    const regex = new RegExp(inSquareBrackets);
    let tempModel = basemodel;

    while ((match = regex.exec(tempModel)) !== null) {
        hits.push({complete: match[0], fo: match[1]});

        // Wichtig: Wenn der reguläre Ausdruck kein global Flag hat,
        // müssen wir den Startindex manuell verschieben, um eine Endlosschleife zu vermeiden
        if (!regex.global) {
            tempModel = tempModel.substring(match.index + match[0].length);
        }
    }


    return hits.reduce((model, hit)=>{
        const abkuerzung = getAbkuerzungFromSelectedFeatures(selectedFeatures, hit.fo);
        if(abkuerzung !== null) {
            return model.replace(hit.complete, abkuerzung);
        }
        alertIfDebug("fo "+hit.fo+ " not found in getModelName! da ist ein Fehler in der Verdatung!");
        return model.replace(hit.complete, "<noFeaturedObject>" + hit.fo + "</noFeaturedObject>");

    }, basemodel);
}
